import { CountUp } from 'countup.js';

(function() {
  var menuItems = document.querySelectorAll('.main-nav li');
  menuItems.forEach( element => {
    element.setAttribute('itemscope', 'itemscope');
    element.setAttribute('itemtype', 'https://www.schema.org/SiteNavigationElement' );
  });
}() );

/** chain link readmore */
function chainLinkHideShow(mainContent, sidebar) {
  sidebar = document.getElementById(sidebar);
  mainContent = document.getElementById(mainContent);
  sidebar.classList.toggle( 'mobile-toggle-hidden' );
  mainContent.classList.toggle( 'mobile-toggle-hidden' );
}

function showNav() {
  var navContainer = document.querySelector('#nav-container');
  var navBar = document.querySelector('.navbar');
  var menuIndicator = document.querySelector('.menu-indicator');
  var menuIndicatorOpen = document.querySelector('.menu-indicator-open');
  var body = document.querySelector('body');

  if ( navContainer ) {
    navContainer.classList.add('show');
    navBar.classList.add('nav-open');
    menuIndicator.classList.add('hide');
    menuIndicatorOpen.classList.remove('hide');
    body.classList.add('menu-open');
  }
}

function hideNav() {
  var navContainer = document.querySelector('#nav-container');
  var navBar = document.querySelector('.navbar');
  var menuIndicator = document.querySelector('.menu-indicator');
  var menuIndicatorOpen = document.querySelector('.menu-indicator-open');
  var body = document.querySelector('body');

  if ( navContainer ) {
    navContainer.classList.remove('show');
    navBar.classList.remove('nav-open');
    menuIndicator.classList.remove('hide');
    menuIndicatorOpen.classList.add('hide');
    body.classList.remove('menu-open');
  }
}

document.addEventListener('DOMContentLoaded', function() {
	const toggleButtons = document.querySelectorAll('.navbar-toggler-icon');
	toggleButtons.forEach(button => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				showNav();
			})
		}
	)

	const toggleCloseButtons = document.querySelectorAll('.navbar-toggler-icon-close');
	toggleCloseButtons.forEach(button => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			hideNav();
		})
	})
})

/* number counters */
jQuery(document).ready(function($) {
  const countUpCaptions = document.querySelectorAll('.counter-wrapper + .counter-caption-wrapper');
  if (countUpCaptions) {
    // set IntersectionObserver on each caption and add the animate class when it's in view
    countUpCaptions.forEach(caption => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            caption.classList.add('animate');
          }
        });
      });
      observer.observe(caption);
    });
  }


  // delay listeners
  var scrolling = false;
  var sizing = false;
  var animated = [];

  window.addEventListener( 'scroll', function() {
    scrolling = true;
  });

  window.addEventListener( 'resize', function() {
    sizing = true;
  });

  // initial call
  var numbers = document.querySelectorAll('.counter:not(.counter-unit):not(.counter-prefix)');
  if ( numbers.length > 0 ) {
    for( var i = 0; i < numbers.length; i++ ) {
      animated[i] = false;
      animate_numbers( numbers[i], i );
    }
  }

  setInterval( function() {
    if ( scrolling || sizing ) {
      scrolling = false;
      sizing = false;
      if ( numbers.length > 0 ) {
        for( var i = 0; i < numbers.length; i++ ) {
          if ( !animated[i] ) {
            animate_numbers( numbers[i], i );
          }
        }
      }
    }
  }, 500 );

  function is_on_screen( element ) {

    var numberTop = totalOffsetTop( element, element.offsetTop );
    var screenHeight = window.innerHeight;

    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
    var scrollHeight = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

    if ( screenHeight + scrollHeight - 100 > numberTop ) {
      return true;
    }

    return false;
  }

  function totalOffsetTop( element ) {
    var top = 0, left = 0;
    do {
        top += element.offsetTop || 0;
        element = element.offsetParent;
    } while(element);

    return top;
  }

  function animate_numbers( element, item ) {

    if ( is_on_screen( element ) ) {
      setTimeout(function() {
        element.classList.remove('animate');
        element.classList.add('animation-done');
      }, 2000 );
      animated[item] = true;

      var useGrouping = false;
      if ( element.dataset.separator == ',' ) {
        useGrouping = true;
      }

      const options = {
        startVal: 0,
        decimalPlaces: element.dataset.decimalPlaces,
        duration: 2.5,
        useGrouping: useGrouping,
        useEasing: true,
        separator: element.dataset.separator,
        decimal: '.'
      }

      var num_anim = new CountUp( element.id, element.dataset.end, options );
      num_anim.start();
    }
  }

  // replicate the desktop sidebars wherever they may be
  var mobile_sidebars = document.querySelectorAll('.sidebar_mobile_placeholder');
  var desktop_sidebar;
  if ( mobile_sidebars ) {
    for (var i = 0; i < mobile_sidebars.length; i++ ) {
      desktop_sidebar = document.getElementById(mobile_sidebars[i].dataset.sidebarId);
      if ( desktop_sidebar ) {
        $(desktop_sidebar).clone().appendTo(mobile_sidebars[i]);
      }
    }
  }
  // load pardot form + modal
  if ( document.querySelector('[data-micromodal-trigger]') ) {
    MicroModal.init();
  }

  // close the main menu when an anchor is clicked (mobile)
  // select menu items with href that contains a hash with a value
  var jumpLinks = document.querySelectorAll('#nav-container a[href*="#"]:not([href="#"])');
  if ( jumpLinks ) {
    for (var i = 0; i < jumpLinks.length; i++ ) {
      jumpLinks[i].addEventListener( 'click', hideNav );
    }
  }

  // Enable expandable menus with empty parent menu items
  var dropdownAnchors = document.querySelectorAll('.menu-item-has-children a[href="#"]');
  if ( dropdownAnchors ) {
      dropdownAnchors.forEach(function (anchor) {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          anchor.parentElement.toggleAttribute('aria-expanded');
        });
      })
    }

  });

/*
// Country menus - disable the region landing page click, instead expand menu.
// comment out to enable region landing pages.
(function() {
  var countryMenu = document.querySelector('.country-menu');
  if ( countryMenu ) {
    countryMenu.addEventListener('click', function(e) {
      if ( e.target.parentElement.classList.contains('dynamic') ) {
        e.preventDefault();
        var currentItem = e.target.parentElement;
        currentItem.classList.toggle('current-menu-item');
        currentItem.classList.toggle('page_item');
        currentItem.classList.toggle('current_page_item');

        var siblings = currentItem.parentElement.childNodes;
        for ( var i = 0; i < siblings.length; i++ ) {
          if ( siblings[i].nodeName == 'LI' && siblings[i].id != currentItem.id ) {
            siblings[i].classList.remove('current-menu-item');
            siblings[i].classList.remove('page_item');
            siblings[i].classList.remove('current_page_item');
            siblings[i].classList.remove('current-page-ancestor');
          }
        }
      }
    });
  }
}());
*/

// slick slider on landing page
jQuery(document).ready(function() {
  function landingSlide() {
    if ( document.querySelector('.intro_stats') ) {
      let screenSize = window.matchMedia( "(max-width: 1024px)" );
      if ( screenSize.matches ) {
        $('.intro_stats').slick({
          dots: true,
          arrows: true,
          infinite: true,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
      screenSize.addEventListener("change", (e) => {
        if ( screenSize.matches ) {
          $('.intro_stats').slick({
            dots: true,
            arrows: true,
            infinite: true,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1
          });
        } else {
          $('.intro_stats').slick('unslick');
        }
      });
    }
  }
  landingSlide();
});

// special calculated stat mobile text swapping
(function() {

  matchMedia('(max-width: 1023px)').addEventListener('change', splitStatCaption);
  splitStatCaption();

  function splitStatCaption() {
    let calculatedStatCaption = document.querySelector('.calculated-stat--result-caption');
    if ( calculatedStatCaption ) {
      if (matchMedia('(max-width: 1023px)').matches) {
        if ( calculatedStatCaption.innerHTML.indexOf('/') ) {
          calculatedStatCaption.innerHTML = calculatedStatCaption.innerHTML.replace( '/', '<br>' );
        }
      } else {
        if ( calculatedStatCaption.innerHTML.indexOf('<br>') ) {
          calculatedStatCaption.innerHTML = calculatedStatCaption.innerHTML.replace( '<br>', '/' );
        }
      }
    }
  }
}());

// country accordion thing
(function() {
  let countryAccordions = document.querySelectorAll('.country-accordion-trigger');
  if ( !countryAccordions || countryAccordions.length == 0 ) {
    return;
  }

  countryAccordions.forEach( (element) => {
    element.addEventListener( 'click', toggleAccordion );
  });

  function toggleAccordion(event) {
    if ( 'keyup' === event.type && ( "Enter" === event.code || "NumpadEnter" === event.code ) || "click" === event.type ) {
      let aButton = event.target;
      let aTarget = aButton.getAttribute('aria-controls');
      if ( 'true' === event.target.getAttribute('aria-expanded') ) {
        aButton.setAttribute('aria-expanded', 'false');
        aButton.nextElementSibling.setAttribute('aria-expanded', 'false');
      } else {
        aButton.setAttribute('aria-expanded', 'true');
        aButton.nextElementSibling.setAttribute('aria-expanded', 'true');
      }
    }
  }

  // collapse all but the first accordion when loading on mobile
    if ( matchMedia('(max-width: 767px)').matches ) {
      countryAccordions.forEach( (element, index) => {
        if ( index > 0 ) {
          element.setAttribute('aria-expanded', 'false');
          element.nextElementSibling.setAttribute('aria-expanded', 'false');
        }
      });
    }
}());
